import React, { useState, createContext, useContext } from 'react';
// Define the shape of a saved report
export interface SavedReport {
  id: string;
  name: string;
  type: string;
  date: string;
  savedAt: Date;
}
// Define the context shape
interface ReportContextType {
  savedReports: SavedReport[];
  saveReport: (report: Omit<SavedReport, 'id' | 'savedAt'>) => void;
  deleteReport: (id: string) => void;
}
// Create the context with default values
const ReportContext = createContext<ReportContextType | undefined>(undefined);
// Create a provider component
export const ReportProvider: React.FC<{
  children: ReactNode;
}> = ({
  children
}) => {
  const [savedReports, setSavedReports] = useState<SavedReport[]>([]);
  const saveReport = (report: Omit<SavedReport, 'id' | 'savedAt'>) => {
    const newReport: SavedReport = {
      ...report,
      id: Date.now().toString(),
      savedAt: new Date()
    };
    setSavedReports(prevReports => [...prevReports, newReport]);
  };
  const deleteReport = (id: string) => {
    setSavedReports(prevReports => prevReports.filter(report => report.id !== id));
  };
  return <ReportContext.Provider value={{
    savedReports,
    saveReport,
    deleteReport
  }} data-id="element-317">
      {children}
    </ReportContext.Provider>;
};
// Create a custom hook to use the context
export const useReportContext = () => {
  const context = useContext(ReportContext);
  if (context === undefined) {
    throw new Error('useReportContext must be used within a ReportProvider');
  }
  return context;
};